/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Label/view.blocks to change it.
import "DesignSystem/Fonts/Inter-500.css"
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Label({
  children,
  viewPath = "/DesignSystem/Label",
  text = "",
  color = "#606060",
  fontSize = 10,
  textTransform = "uppercase",
  textDecorationLine = "none",
  textOverflow = "clip",
  marginBottom = 6,
  marginLeft = 0,
  marginTop = 0,
  marginRight = 0,
  flexGrow = 0,
  whiteSpace = "nowrap",
  lineClamp = "none",
  overflowX = "hidden",
  maxWidth = "auto",
  paddingTop = 0,
  paddingBottom = 0,
  paddingLeft = 0,
  paddingRight = 0,
  backgroundColor = "transparent",
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0
  
}) {
  return (<React.Fragment
>
<span
  data-testid="Label.Text"
  data-view-path={viewPath}
 style={{'--c-1-5hnkT': color,'--fs-2-5hnkT': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--tt-3-5hnkT': textTransform,'--tdl-4-5hnkT': textDecorationLine,'--to-5-5hnkT': textOverflow,'--mb-6-5hnkT': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-7-5hnkT': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mt-8-5hnkT': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-9-5hnkT': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-6-5hnkT': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--fg-10-5hnkT': flexGrow,'--ws-11-5hnkT': whiteSpace,'--lc-12-5hnkT': lineClamp,'--ox-13-5hnkT': overflowX,'--to-5-5hnkT': textOverflow,'--mw-14-5hnkT': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--pt-15-5hnkT': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-16-5hnkT': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-17-5hnkT': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-18-5hnkT': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--bc-19-5hnkT': backgroundColor,'--btlr-20-5hnkT': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-21-5hnkT': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--bblr-22-5hnkT': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-23-5hnkT': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
{children}
</React.Fragment>)
}